export default __webpack_public_path__ + "static/field-home-1b5966832aa55cefb3a93bfa71925451.png";